import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

function scrollToHash(hash: string): boolean {
  const targetId = decodeURIComponent(hash.slice(1));
  if (!targetId) return false;

  const target = document.getElementById(targetId);
  if (!target) return false;

  target.scrollIntoView({ behavior: 'auto', block: 'start' });
  return true;
}

export default function ScrollToTop() {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    if (typeof window === 'undefined') return;

    const previousScrollRestoration = window.history.scrollRestoration;
    window.history.scrollRestoration = 'manual';

    return () => {
      window.history.scrollRestoration = previousScrollRestoration;
    };
  }, []);

  useEffect(() => {
    if (typeof window === 'undefined') return;

    const frame = window.requestAnimationFrame(() => {
      if (hash && scrollToHash(hash)) return;

      window.scrollTo({ top: 0, left: 0, behavior: 'auto' });
    });

    return () => window.cancelAnimationFrame(frame);
  }, [pathname, hash]);

  return null;
}
